/** Classic C: a brick maze with diamonds in its dead ends and boulders in its corridors (docs/spec/03 §2). */

import type { CaveDef } from '../types';

export const caveC: CaveDef = {
  id: 'C',
  name: 'LABYRINTH',
  hint: 'The dead ends are worth the detour.',
  intermission: false,
  colors: [6, 15, 7],
  diamondValue: 12,
  extraValue: 20,
  fill: { base: '.', items: [['d', 3], [' ', 6]] },
  levels: [
    { seed: 1301, diamonds: 10, time: 150 },
    { seed: 1302, diamonds: 12, time: 140 },
    { seed: 1303, diamonds: 14, time: 130 },
    { seed: 1304, diamonds: 16, time: 120 },
    { seed: 1305, diamonds: 18, time: 110 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'WPwd????wdw???w???????w?????w?????????wW',
    'W?www?w?w?w?w?w?wwwww?w?w?w?w?wwwwwww?wW',
    'W?w???w?w???w?r???w???w?w?wdw??????dw?wW',
    'W?w?www?www?w?www?w?www?w?wwwww?w?www?wW',
    'W?w?wdw?????w?w???w?????w???????w???r?wW',
    'W?w?w?www?www?wrwwwww?w?wwwwwwwww?www?wW',
    'W???w???w???w?w????dw?w???wd????w???w?wW',
    'Wwwwwww?www?w?w?wwwww?www?wwwww?wwwrw?wW',
    'Wd????????w???????????wdw????????dw?w?wW',
    'Wwwwwrwwwrw?www?w?wwwrw?wwwwwww?www?w?wW',
    'W?????w???w???w?w?wd??r??dw?????????w?wW',
    'W?wwwww?wwwww?w?w?wwwww?www?www?wrwww?wW',
    'W???w???w?????w?w???w?????w?????w?wd??wW',
    'W?w?w?wwwrw?w?w?w?w?w?www?wwwww?w?wwwwwW',
    'W???r?????w???r???w????dw?????????w???wW',
    'W?wwwwwww?w?wwwww?wwwwwwwww?wrw?w?w?w?wW',
    'W?????????w???wd?????dw???wdw???w?????wW',
    'W?w?w?wwwwwww?wwwwwwwww?w?www?wwwww?wrwW',
    'W???w???????????????????w????????????XwW',
    'WwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwW',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
